import { useState } from "react";
import {
  BsFillArrowRightCircleFill,
  BsFillArrowLeftCircleFill,
} from "react-icons/bs";


export default function Carousel({ slides }) {
  let [current, setCurrent] = useState(0);

  let previousSlide = () => {
    if (current === 0) setCurrent(slides.length - 1);
    else setCurrent(current - 1);
  };

  let nextSlide = () => {
    if (current === slides.length - 1) setCurrent(0);
    else setCurrent(current + 1);
  };

  return (
    <div className="overflow-hidden relative">
      <div
        className={`flex transition ease-out duration-40`}
        style={{
          transform: `translateX(-${current * 100}%)`,
        }}
      >
        {slides.map((s) => {
          // eslint-disable-next-line jsx-a11y/alt-text
          return <img src={s} />;
        })}
      </div>

      <div className="absolute top-0 h-full w-full justify-between items-center flex text-white px-5 text-2xl">
        <button onClick={previousSlide}>
          <BsFillArrowLeftCircleFill style={{ color: "white", opacity: 0.3 }}/>
        </button>
        <button onClick={nextSlide}>
          <BsFillArrowRightCircleFill style={{ color: "white", opacity: 0.3 }}/>
        </button>
      </div>
      
    </div>
  );
}